import React, {useEffect, useRef, useState} from 'react';
import cn from 'classnames';

import {useDebouncedCallback} from 'coreHooks';

import {ModuleLinks, ModuleText} from '../Common';

import CarouselModuleBody from './CarouselModuleBody/CarouselModuleBody';
import {ICarouselModule} from './ICarouselModule';

import styles from './CarouselModule.module.scss';

const CarouselModule = ({
	title,
	body,
	textColorVariant,
	variant,
	productIds,
	links,
	backgroundColor,
}: ICarouselModule) => {
	const contentBackground = backgroundColor === 'grey' ? '#EEEDF0' : '#ffffff';
	const isCarousel = body?.[0].props?.__typename === 'Carousel';
	const [titleHeight, setTitleHeight] = useState(0);
	const titleRef = useRef<HTMLDivElement>(null);
	const carouselStyle = {
		'--display-pagination-desktop': body?.[0]?.props?.children?.length > 4 ? 'block' : 'none',
		'--pagination-color': body?.[0].props?.paginationColor || '#da291c',
		'--content-background-color': contentBackground,
		'--carousel-title-height': `${titleHeight}px`
	} as React.CSSProperties;

	const updateTitleHeight = () => {
		if (titleRef.current) {
			setTitleHeight(titleRef.current.offsetHeight);
		}
	};

	const debouncedUpdateTitleHeight = useDebouncedCallback(updateTitleHeight, 200);

	useEffect(() => {
		updateTitleHeight(); // Calculate the height initially
		window.addEventListener('resize', debouncedUpdateTitleHeight);

		return () => {
			window.removeEventListener('resize', debouncedUpdateTitleHeight);
			debouncedUpdateTitleHeight.cancel();
		};
	}, [title]);

	return (
		<div className={cn('carousel-module', styles['carousel-module'], {[styles[`${variant}`]]: variant})} style={carouselStyle}>
			<div ref={titleRef} className={styles['carousel-module__title']}>
				{title && (
					<ModuleText contentfulField="title" colorVariant={textColorVariant} text={title} />
				)}
				{links && <ModuleLinks>{links}</ModuleLinks>}
			</div>
			{isCarousel ? (
				<div className={styles['carousel-module__body']}>
					{productIds ? <CarouselModuleBody body={body} productIds={productIds} /> : <>{body}</>}
				</div>
			) : (
				<div className={styles['carousel-module__grid']}>{body}</div>
			)}
		</div>
	);
};

export default CarouselModule;
